export default [
  {
    value: 'id',
    locale: 'objects.ID',
    width: '50px',
  },
  {
    value: 'name',
    locale: 'objects.name',
  },
  {
    value: 'instagram',
    locale: 'objects.routing.chatGateways.messenger.instagram.instagram',
  },
  {
    value: 'accounts',
    locale: 'objects.routing.chatGateways.messenger.accounts',
  },
];
